import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { SearchCouponComponent } from "../../../../components/modal/search-coupon/search-coupon.component";
import { EventsService } from "../../../../components/events/event.service";

@Component({
  selector: "app-activate-coupon",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./activate-coupon.component.html",
  styleUrl: "./activate-coupon.component.scss",
})
export class ActivateCouponComponent {
  @Input() token: string;
  constructor(
    private modalService: NgbModal,
    private eventService: EventsService
  ) {}

  openModalSearchCoupon() {
    const modal = this.modalService.open(SearchCouponComponent, {
      centered: true,
      backdrop: "static",
      size: "md",
    });
    modal.componentInstance.token = this.token;
    /*modal.result.then((result: any) => {
      this.eventService.sendInvites(this.token, result).subscribe({
        next: (res) => {},
      });
    });*/
  }
}
